<template>
  <div class="profile">
    <template v-if="$auth.loggedIn">
      <profile-menu-link
        v-qa="'profile_page_link'"
        :redirect-link="WEB_ROUTES.PROFILE"
        :icon="iconsEnum.user">
        {{ $t('header.menu-profile') }}
      </profile-menu-link>

      <profile-menu-link
        v-qa="'my-loan_page_link'"
        :redirect-link="WEB_ROUTES.PROFILE_MY_LOAN"
        :icon="iconsEnum.wallet">
        {{ $t('header.menu-my-loan') }}
      </profile-menu-link>

      <profile-menu-link
        v-qa="'legal_document_page_link'"
        :redirect-link="WEB_ROUTES.PROFILE_LEGAL_DOCUMENTS"
        :icon="iconsEnum.document">
        {{ $t('header.menu-documents') }}
      </profile-menu-link>

      <div v-qa="'login_authorized_menu_logout'" class="sf-fr" @click="$auth.logout">
        <logout class="profile__icon sf-mr-xs"/>
        {{ $t('header.menu-logout') }}
      </div>
    </template>

    <template v-else>
      <profile-menu-link
        v-qa="'my-loan_page_link'"
        :redirect-link="WEB_ROUTES.LOGIN"
        :icon="iconsEnum.user">
        {{ $t('header.menu-login') }}
      </profile-menu-link>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Logout from '~/static/img/profile/logout.svg';
import { WEB_ROUTES } from '~/app/shared/utils/web-config';
import ProfileMenuLink from '~/components/header/profile-menu-link.vue';
import { iconsEnum } from '~/app/shared/utils/consts';

export default {
  components: { ProfileMenuLink, Logout },
  computed: {
    iconsEnum() {
      return iconsEnum;
    },
    ...mapState('client', ['loan']),
    WEB_ROUTES() {
      return WEB_ROUTES;
    },
    hasLegalDocuments() {
      return this.loan && this.loan.hasLegalDocuments;
    },
  },
};
</script>

<style lang="scss" scoped>
.profile {
  & > * {
    white-space: nowrap;
    color: map-get($map: $colors, $key: text);
    transition: all 0.3s;

    @include not-desktop {
      margin-bottom: 30px;
      font-weight: 700;
    }

    @include desktop {
      padding: 20px 60px 20px 10px;
      border-bottom: 1px solid map-get($map: $colors, $key: border);
    }

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }

    &.active-url {
      font-weight: 600;
      color: map_get($colors, primary);

      @include mobile {
        fill: map-get($map: $colors, $key: ternary);
        color: map-get($map: $colors, $key: ternary);
      }
    }
  }

  &__icon {
    @include square(20px);
  }
}
</style>
